import { CardContentClassKey, StyleRules } from "@material-ui/core";

export const MuiCardContent: Partial<StyleRules<CardContentClassKey, {}>> = {
  root: {
    "&:last-child": {
      paddingBottom: 15,
    },
  },
};
